import {PostService} from './PostService';

export {PostService};